import { Injectable } from '@angular/core';

// The localStorage key ProbateListComponent persists its filter/search state under (see
// ProbateListComponent.saveFiltersToStorage/restoreFiltersFromStorage). Exposed here as a tiny
// singleton so other parts of the app (login/logout, the "Probate List" nav button) can clear it
// without duplicating the key string or depending on ProbateListComponent directly.
export const PROBATE_LIST_FILTERS_KEY = 'probate-list-filters';

@Injectable({ providedIn: 'root' })
export class ProbateListFilterStorageService {
  // Set by requestReset(), consumed once by ProbateListComponent.ngOnInit(). A plain
  // localStorage.removeItem() at the moment of the request isn't enough on its own: this app's
  // RouteReuseStrategy (NoReuseStrategy) plus onSameUrlNavigation: 'reload' mean pressing
  // "Probate List" while already on that screen destroys and recreates the component - so if
  // ProbateListComponent is the one being navigated away from, Angular destroys that outgoing
  // instance AFTER requestReset() runs, and its ngOnDestroy unconditionally re-saves whatever
  // filters it currently holds, silently undoing the removeItem an instant later. This flag
  // survives that, because the new instance checks it in ngOnInit, which always runs after any
  // outgoing instance's ngOnDestroy has already finished - so the reset always wins regardless
  // of which route (if any) is being navigated away from.
  private resetRequested = false;

  // Called on logout, login, and pressing the "Probate List" nav button (see AppComponent) -
  // marks the list as needing a fresh start the next time it initialises, however that happens.
  requestReset(): void {
    this.resetRequested = true;
    localStorage.removeItem(PROBATE_LIST_FILTERS_KEY);
  }

  // One-shot check-and-clear, called once at the very start of ProbateListComponent.ngOnInit(),
  // before it decides whether to restore anything from storage.
  consumeResetRequest(): boolean {
    const wasRequested = this.resetRequested;
    this.resetRequested = false;
    return wasRequested;
  }
}
